import { getLang } from './i18n';

// Brand colours taken from the Dawaa Alhayat logo: violet → steel blue → turquoise.
export const colors = {
  violet: '#5A1F82',
  violetDark: '#4A1872',
  steel: '#3B7DB8',
  turquoise: '#0AABC9',
  turquoiseDark: '#06627A',
  bg: '#F6F4FA',
  card: '#FFFFFF',
  text: '#231F20',
  muted: '#6F6880',
  faint: '#9A93A8',
  border: '#ECE8F3',
  violetTint: '#EFE7F7',
  turquoiseTint: '#DDF4F9',
  greyTint: '#EEECF2',
  danger: '#A32D2D',
  dangerDark: '#791F1F',
  dangerTint: '#FCEBEB',
  success: '#1D7A55',
  successTint: '#E1F5EE',
  warning: '#854F0B',
  warningTint: '#FAEEDA',
  white: '#FFFFFF',
};

/** Header / primary-button gradient, as in the logo. */
export const brandGradient = [colors.violetDark, colors.violet, colors.steel, colors.turquoise] as const;
export const buttonGradient = [colors.violet, colors.turquoise] as const;

export const radius = { sm: 10, md: 14, lg: 18, xl: 26 };

// Fonts are loaded per weight (one family name per weight). Cairo lacks the Sorani letters
// (ە ێ ڕ ۆ ڵ), so Kurdish uses Noto Kufi Arabic, a close Kufi design that has them all.
// Getters: read at render time, so switching language (which remounts the app) switches the font.
const pick = (cairo: string, kufi: string) => (getLang() === 'ku' ? kufi : cairo);
export const font = {
  get regular() { return pick('Cairo_400Regular', 'NotoKufiArabic_400Regular'); },
  get semibold() { return pick('Cairo_600SemiBold', 'NotoKufiArabic_600SemiBold'); },
  get bold() { return pick('Cairo_700Bold', 'NotoKufiArabic_700Bold'); },
  get black() { return pick('Cairo_800ExtraBold', 'NotoKufiArabic_800ExtraBold'); },
};
